export default {
    title: 'Components/Cards/Centered Image Card',
    // tags: ['autodocs'],
    argTypes: {
      image_src: {
        control: 'text',
        description: 'Path to the image of the team member',
      },
      image_alt: {
        control: 'text',
        description: 'Image alternate text',
      },
      header_text: {
        control: 'text',
        description: 'Header text for the information card',
      },
      date_text: {
        control: 'text',
        description: 'Date text for the information card',
      },
      body_text: {
        control: 'text',
        description: 'Body text for the information card',
      },
      left_button_name: {
        control: 'text',
        description: 'Name of the left button',
      },
      right_button_name: {
        control: 'text',
        description: 'Name of the right button',
      },
      left_button_id:{
        control: 'text',
        description: 'ID of left button',
      },
      right_button_id:{
        control: 'text',
        description: 'ID of right button',
      },
      // single_button: {
      //   control: 'boolean',
      //   description: 'Name of the single button',
      // },
      custom_class: {
        control: { type: 'text' },
        description: 'Custom class for the credit card component',
      },
      component_mode: {
        control: { type: 'check' },
        options: ['light-mode'],
        description: 'Mode of the credit card component',
      }
      
    },
    parameters: {
      docs: {
        description: {
          component: `
  To use the \`dda-centered-image-card\` component, pass the following props:
  
  \`\`\`html
<dda-centered-image-card
    image_src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvhlzYedWoCSkLB2HFQ87P5gPjCmJqmTt8vw&s"
    image_alt="Alternate text"
    header_text="Backend Team"
    date_text="31 September 2024"
    body_text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    left_button_name="Cancel"
    right_button_name="Continue"
    // single_button="false"
    custom_class=""
    component_mode=""
></dda-centered-image-card>
    \`\`\`
  `,
        },
      },
    },  
  };
  
  const Template = (args) => {
    const attributes = Object.entries(args)
      .filter(([key, value]) => value !== undefined && key !== 'text')
      .map(([key, value]) => `${key}="${value}"`)
      .join(' ');
  
    return `<dda-centered-image-card ${attributes}></dda-centered-image-card>`;
  };
  
  export const Default = Template.bind({});
  Default.args = {
    image_src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvhlzYedWoCSkLB2HFQ87P5gPjCmJqmTt8vw&s',
    image_alt: "Alternate text",
    header_text: "Backend Team",
    date_text: "31 September 2024",
    body_text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    left_button_name: "Cancel",
    right_button_name: "Continue",
    left_button_id: "primaryButton",
    right_button_id: "seconderyButton",
    // single_button: false,
    onclick: "console.log('clicked')",
    custom_class: '',
    component_mode: '',
  };

